import { MonetaLogo } from "@/components/atoms/MonetaLogo";
import { useViewportHeight } from "@/hooks";

import * as styles from "./styles";

interface PublicPageProps {
  children: React.ReactNode;
  title: React.ReactNode;
}

export const PublicPage = ({ children, title }: PublicPageProps) => (
  <styles.Container style={useViewportHeight()?.boxStyle}>
    <styles.LayoutContent>
      <styles.LogoWrapper>
        <MonetaLogo height={62} />
      </styles.LogoWrapper>
      {title && <styles.Title>{title}</styles.Title>}
      {children}
    </styles.LayoutContent>
  </styles.Container>
);
